import 'whatwg-fetch'
import config, {AUTH_INVALID_TOKEN} from '../../config/config'
import {dropToken} from "../../components/UserLogin/actions"
import {toastr} from "react-redux-toastr"

export const REQUEST_MEETS = 'REQUEST_MEETS'
export const RECEIVE_MEETS = 'RECEIVE_MEETS'
export const RECEIVE_1PAGE_MEETS = 'RECEIVE_1PAGE_MEETS'
export const RECEIVE_SINGLE_MEET = 'RECEIVE_SINGLE_MEET'
export const REQUEST_MEETS_TIME = 'REQUEST_MEETS_TIME'
export const RECEIVE_MEETS_TIME = 'RECEIVE_MEETS_TIME'
export const MEETS_PAGE_COUNT = 15
export const REQUEST_VENUES = 'REQUEST_VENUES'
export const RECEIVE_VENUES = 'RECEIVE_VENUES'

export const requestMeets = () => ({
    type: REQUEST_MEETS,
})

export const receiveMeets = (meets) => ({
    type: RECEIVE_MEETS,
    meets,
})

export const receiveSingleMeet = (meet) => ({
    type: RECEIVE_SINGLE_MEET,
    meet
})

export const receive1PageMeets = (meets) => ({
    type: RECEIVE_1PAGE_MEETS,
    meets,
})

export const requestMeetsTime = () => ({
    type: REQUEST_MEETS_TIME,
})

export const receiveMeetsTime = (time) => ({
    type: RECEIVE_MEETS_TIME,
    time,
})

export const requestVenues = () => ({
    type: REQUEST_VENUES,
})

export const receiveVenues = (venues) => ({
    type: RECEIVE_VENUES,
    venues,
})

const process_api_error = (json, dispatch, t) => {
    if (json.code === AUTH_INVALID_TOKEN) {
        dispatch(dropToken())
    }
    toastr.error(t('serverError') + String(json.code) + '. ' + json.message)
}

export const fetchMeets = (token = null, params = {}, t) => (dispatch) => {
    dispatch(requestMeets())
    const headers = { Authorization: 'Bearer ' + token }

    let url
    if (params && params.id) {
        url = config.API_MEETS_URL + '?id=' + String(params.id)
    } else {
        url = config.API_MEETS_URL
            + '?'
            + Object.keys(params)
                .filter(k => params[k] != null && params[k] !== '' && (!Array.isArray(params[k]) || params[k].length > 0))
                .map((k) => k + '=' + encodeURIComponent(params[k]))
                .join('&')
    }

    return fetch(url, { headers, credentials: 'include' }, )
        .then(res => res.json())
        .then((json) => {
            if (json.code === 200) {
                if (params.id) {
                    dispatch(receiveSingleMeet(json.data))
                    return json.data
                } else {
                    dispatch(params.page === 1 ? receive1PageMeets(json.data) : receiveMeets(json.data))
                    return json.data
                }
            } else {
                process_api_error(json, dispatch, t)
            }
        })
        .catch((err) => {
            toastr.error(t('requestError') + String(err))
        })
}

export const editMeet = (token = null, id, params = {}, t) => (dispatch) => {
    dispatch(requestMeets())

    const headers = token ? {
        Authorization: 'Bearer ' + token,
    } : {}

    let url = config.API_EDIT_MEET_URL + String(id)

    const formData = new FormData()
    Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
            formData.append(key, params[key])
        }
    })

    return fetch(url, {
        method: 'post',
        headers,
        credentials: 'include',
        body: formData
    })
        .then((res) => res.json())
        .then((json) => {
            if (json.code === 200) {
                dispatch(receiveSingleMeet(json.data))
            } else {
                process_api_error(json, dispatch, t)
            }
        })
        .catch((err) => {
            toastr.error(t('requestError') + String(err))
        })
}

export const fetchTimeMeets = (token = null, t) => (dispatch) => {
    dispatch(requestMeetsTime())
    const headers = { Authorization: 'Bearer ' + token }

    const url = config.API_MEET_TIME_URL

    return fetch(url, { headers, credentials: 'include' })
        .then(res => res.json())
        .then((json) => {
            if (json.code === 200) {
                dispatch(receiveMeetsTime(json.data))
            } else {
                process_api_error(json, dispatch, t)
            }
        })
        .catch((err) => {
            toastr.error(t('requestError') + String(err))
        })
}

export const fetchVenues = (params = {}, t) => (dispatch) => {
    dispatch(requestVenues())

    const url = config.API_VENUES_URL

    return fetch(url, { credentials: 'include' })
        .then(res => res.json())
        .then((json) => {
            if (json.code === 200) {
                dispatch(receiveVenues(json.data))
            } else {
                process_api_error(json, dispatch, t)
            }
        })
        .catch((err) => {
            toastr.error(t('requestError') + String(err))
        })
}